import React, { useState } from "react";
import { Popover } from "@mui/material";
import { TotalRow } from "@/dentlab/src/pages/job-page/job-document/job-document-components/total-sidebar.component";

export const JobItemsTotalsPopover: React.FC<{ rows: TotalRow[]; totalText: string }> = ({ rows, totalText }) => {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const open = Boolean(anchorEl);

    return (
        <>
            <span
                onMouseEnter={(e) => setAnchorEl(e.currentTarget)}
                onMouseLeave={() => setAnchorEl(null)}
                className="cursor-default"
            >
                {totalText}
            </span>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                disableRestoreFocus
            >
                <table className="p-2">
                    <tbody className="flex flex-col gap-1">
                        {rows.map((row) => (
                            <tr
                                key={row.name}
                                style={{ borderBottom: row.borderBottom ? "1px solid #e0e0e0" : undefined }}
                            >
                                <td style={{ width: "140px", fontWeight: row.bold ? "bold" : "normal" }}>{row.name}</td>
                                <td style={{ fontWeight: row.bold ? "bold" : "normal" }}>{row.value}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Popover>
        </>
    );
};

